// Models
export var PlannerChatThreadType;
(function(PlannerChatThreadType) {
    /** The thread for task chat */ PlannerChatThreadType["Task"] = "task";
    /** The thread for plan chat */ PlannerChatThreadType["Plan"] = "plan";
})(PlannerChatThreadType || (PlannerChatThreadType = {}));
export var PlannerChatReactionEmotion;
(function(PlannerChatReactionEmotion) {
    PlannerChatReactionEmotion["Like"] = "like";
    PlannerChatReactionEmotion["Heart"] = "heart";
    PlannerChatReactionEmotion["Laugh"] = "laugh";
    PlannerChatReactionEmotion["Surprised"] = "surprised";
    PlannerChatReactionEmotion["Sad"] = "sad";
    PlannerChatReactionEmotion["Checkmark"] = "checkmark";
    /** Indicates the reaction of unknown future type, for extensiblity to more types in the future */ PlannerChatReactionEmotion["UnknownFutureValue"] = "unknownFutureValue";
})(PlannerChatReactionEmotion || (PlannerChatReactionEmotion = {}));
export var ChatMentionType;
(function(ChatMentionType) {
    ChatMentionType["User"] = "user";
    ChatMentionType["Application"] = "application";
})(ChatMentionType || (ChatMentionType = {}));
export var ChatMessageType;
(function(ChatMessageType) {
    ChatMessageType["RichText"] = "richTextHtml";
    ChatMessageType["Text"] = "plainText";
})(ChatMessageType || (ChatMessageType = {}));
